module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<form ng-submit="$ctrl.submit()">\n  <h4 translate>My route</h4>\n  <div class="form-group">\n    <epfl-search\n      class="from"\n      selected="$ctrl.from"\n      query="$ctrl.fromQuery"\n      map="::$ctrl.dummyMap"\n      options-name="gmfSearchStartRouting"\n    >\n    </epfl-search>\n  </div>\n  <div class="form-group">\n    <epfl-search\n      class="to"\n      selected="$ctrl.to"\n      query="$ctrl.toQuery"\n      map="::$ctrl.dummyMap"\n      options-name="gmfSearchDestinationRouting"\n    >\n    </epfl-search>\n  </div>\n  <button type="submit" class="btn red-btn" translate>Find my way</button>\n</form>\n';

}
return __p
}